import { DocumentProperty } from "./CBP3461";
import { BaseEntity } from "../common/baseEntity";

export class CBP7501 extends BaseEntity<string> {
    public OrderId: number;
    public Name: string;
    public FilerCode: DocumentProperty = new DocumentProperty();
    public EntryType: DocumentProperty = new DocumentProperty();
    public SummaryDate: DocumentProperty = new DocumentProperty();
    public SuretyNo: DocumentProperty<number> = new DocumentProperty();
    public BondType: DocumentProperty<number> = new DocumentProperty();
    public PortCode: DocumentProperty<number> = new DocumentProperty();
    public EntryDate: DocumentProperty = new DocumentProperty();
    public ImportingCarrier: DocumentProperty = new DocumentProperty();
    public ModeOfTransport: DocumentProperty<number> = new DocumentProperty();
    public CountryOfOrigin: DocumentProperty = new DocumentProperty();
    public ImportDate: DocumentProperty = new DocumentProperty();
    public BillOfLading: DocumentProperty = new DocumentProperty();
    public ManufacturerID: DocumentProperty = new DocumentProperty();
    public ExportingCountry: DocumentProperty = new DocumentProperty();
    public ExportDate: DocumentProperty = new DocumentProperty();
    public ITNo: DocumentProperty = new DocumentProperty();
    public ITDate: DocumentProperty = new DocumentProperty();
    public MissingDocs: DocumentProperty = new DocumentProperty();
    public ForeignPortOfLading: DocumentProperty<number> = new DocumentProperty();
    public USPortOfUnlading: DocumentProperty<number> = new DocumentProperty();
    public LocationOfGoodsGONo: DocumentProperty = new DocumentProperty();
    public ConsigneeNo: DocumentProperty = new DocumentProperty();
    public ImporterNo: DocumentProperty = new DocumentProperty();
    public ReferenceNo: DocumentProperty = new DocumentProperty();
    public UltimateConsigneeNameAndAddress: NameAndAddress = new NameAndAddress();
    public ImporterOfRecordNameAndAddress: NameAndAddress = new NameAndAddress();
    public OtherFeeSummaryForBlock39: DocumentProperty = new DocumentProperty();
    public TotalEnteredValue: DocumentProperty<number> = new DocumentProperty();
    public TotalOtherFees: DocumentProperty<number> = new DocumentProperty();

    //CBP use only
    public LIQCode: DocumentProperty = new DocumentProperty();
    public ReasonCode: DocumentProperty = new DocumentProperty();
    public AscertainedDuty: DocumentProperty<number> = new DocumentProperty();
    public AscertainedTax: DocumentProperty<number> = new DocumentProperty();
    public AscertainedOther: DocumentProperty<number> = new DocumentProperty();
    public AscertainedTotal: DocumentProperty<number> = new DocumentProperty();

    //Totals
    public Duty: DocumentProperty<number> = new DocumentProperty();
    public Tax: DocumentProperty<number> = new DocumentProperty();
    public Other: DocumentProperty<number> = new DocumentProperty();
    public Total: DocumentProperty<number> = new DocumentProperty();

    public DeclarationOfImporterOfRecord: DocumentProperty<number> = new DocumentProperty();
    public DeclarationOfMerchandiseOfRecord: DocumentProperty<number> = new DocumentProperty();
    public DeclarantName: DocumentProperty = new DocumentProperty();
    public Title: DocumentProperty = new DocumentProperty();
    public Signature: DocumentProperty = new DocumentProperty();
    public DeclarantDate: DocumentProperty = new DocumentProperty();
    public BrokerInformation: DocumentProperty = new DocumentProperty();
    public BrokerFileNo: DocumentProperty = new DocumentProperty();

    //Table
    public TableLineInputs: Array<LineInputs> = new Array<LineInputs>();
}

export class LineInputs{
    public LineNumber: DocumentProperty<number> = new DocumentProperty();
    public HTSUSNo: DocumentProperty = new DocumentProperty();
    public ADACVDNo: DocumentProperty = new DocumentProperty();
    public Grossweight: DocumentProperty<number> = new DocumentProperty();
    public ManifestQty: DocumentProperty<number> = new DocumentProperty();
    public NetQuantityInHTSUSUnits: DocumentProperty = new DocumentProperty();
    public EnteredValue: DocumentProperty<number> = new DocumentProperty();
    public CHGS: DocumentProperty = new DocumentProperty();
    public Relationship: DocumentProperty = new DocumentProperty();
    public HTSUSRate: DocumentProperty = new DocumentProperty();
    public ADACVDRate: DocumentProperty = new DocumentProperty();
    public IRCRate: DocumentProperty = new DocumentProperty();
    public VisaNo: DocumentProperty = new DocumentProperty();
    public Dollars: DocumentProperty<number> = new DocumentProperty();
    public Cents: DocumentProperty<number> = new DocumentProperty();
}

export class NameAndAddress {
    public Name: DocumentProperty = new DocumentProperty();
    public City: DocumentProperty = new DocumentProperty();
    public State: DocumentProperty = new DocumentProperty();
    public Zip: DocumentProperty = new DocumentProperty();
}


// WEBPACK FOOTER //
// ./app/objects/documents/CBP7501.ts